import { useEffect } from 'react';

interface ClarityWindow extends Window {
    clarity?: {
        q?: any[];
        (...args: any[]): void;
    };
}

export const useClarity = (projectId: string) => {
    useEffect(() => {
        if (typeof window === 'undefined' || !projectId) return;

        const clarityWindow = window as ClarityWindow;

        // Inicializar Clarity si no existe
        if (!clarityWindow.clarity) {
            clarityWindow.clarity = function(...args: any[]) {
                (clarityWindow.clarity!.q = clarityWindow.clarity!.q || []).push(args);
            };
        }

        // Verificar si el script ya está cargado
        const existingScript = document.querySelector(`script[src*="clarity.ms/tag/${projectId}"]`);
        if (existingScript) return;

        // Crear y agregar el script
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = `https://www.clarity.ms/tag/${projectId}`;

        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript && firstScript.parentNode) {
            firstScript.parentNode.insertBefore(script, firstScript);
        }

        // Cleanup function
        return () => {
            const scriptToRemove = document.querySelector(`script[src*="clarity.ms/tag/${projectId}"]`);
            if (scriptToRemove) {
                scriptToRemove.remove();
            }
        };
    }, [projectId]);
};